/* move-to-space-submenu.tsx generated by @compiled/babel-plugin v2.0.0 */
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0Of8r2gVvo%7Bpadding-top%3Avar(--ds-space-075%2C6px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1Znuxb2ADO%7Bpadding-right%3Avar(--ds-space-100%2C8px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1wydGWgVvo%7Bpadding-bottom%3Avar(--ds-space-075%2C6px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2Zuz6Q2ADO%7Bpadding-left%3Avar(--ds-space-100%2C8px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3iDTPbQ4SZ%7Bdisplay%3Aflex%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0hPCNLDIqT%7Balign-items%3Acenter%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0LQT5EgVvo%7Bpadding-inline-start%3Avar(--ds-space-075%2C6px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0NUa3rGVdc%7Bmax-height%3A15pc%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2WAcuGIZbP%7Boverflow-y%3Aauto%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0Of8r22ADO%7Bpadding-top%3Avar(--ds-space-100%2C8px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1Znuxb8HPE%7Bpadding-right%3Avar(--ds-space-150%2C9pt)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1wydGW2ADO%7Bpadding-bottom%3Avar(--ds-space-100%2C8px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2Zuz6Q8HPE%7Bpadding-left%3Avar(--ds-space-150%2C9pt)%7D");
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useIntl } from 'react-intl';
import type { EmojiProvider } from '@atlaskit/emoji';
import { ResourcedEmoji } from '@atlaskit/emoji/element';
import FolderAddIcon from '@atlaskit/icon-lab/core/folder-add';
import ChevronRightIcon from '@atlaskit/icon/core/chevron-right';
import FolderClosedIcon from '@atlaskit/icon/core/folder-closed';
import SearchIcon from '@atlaskit/icon/core/search';
import ButtonItem from '@atlaskit/menu/button-item';
import MenuGroup from '@atlaskit/menu/menu-group';
import Section from '@atlaskit/menu/section';
import { Popup } from '@atlaskit/popup/popup';
import { Box, Text } from '@atlaskit/primitives/compiled';
import Spinner from '@atlaskit/spinner/spinner';
import Textfield from '@atlaskit/textfield/text-field';
import type { Space } from '@atlassian/rovo-spaces/controllers/space-store/types';
import { TESTID_PREFIX, Z_INDEX_POPUP_COMPONENTS } from '../../../common/constants';
import type { Conversation } from '../../../common/types';
import messages from './messages';
const styles = {
  searchContainer: "_0Of8r2gVvo _1Znuxb2ADO _1wydGWgVvo _2Zuz6Q2ADO",
  searchIconContainer: "_3iDTPbQ4SZ _0hPCNLDIqT _0LQT5EgVvo",
  scrollableList: "_0NUa3rGVdc _2WAcuGIZbP",
  emptyState: "_0Of8r22ADO _1Znuxb8HPE _1wydGW2ADO _2Zuz6Q8HPE"
};
export type MoveToSpaceSubmenuProps = {
  testIdDisambiguator: string;
  conversation: Conversation;
  spaces: Space[];
  isLoadingSpaces: boolean;
  spaceEmojiProvider: Promise<EmojiProvider>;
  onConversationMoveToSpace?: (conversation: Conversation, spaceId: string) => Promise<void>;
  onConversationMoveToNewSpace?: (conversation: Conversation) => void;
  onClose: () => void;
};

/**
 * Submenu rendered as a flyout from the conversation "..." menu's
 * "Move to space" item. Lets the user filter their existing Rovo spaces with
 * a search input, pick one to move the conversation into, or pin a "Create
 * new space" action at the bottom.
 *
 * Always gated by the Rovo Spaces experiment upstream — this component itself
 * does not read rollout state.
 */
export const MoveToSpaceSubmenu = ({
  testIdDisambiguator,
  conversation,
  spaces,
  isLoadingSpaces,
  spaceEmojiProvider,
  onConversationMoveToSpace,
  onConversationMoveToNewSpace,
  onClose
}: MoveToSpaceSubmenuProps): JSX.Element | null => {
  const {
    formatMessage
  } = useIntl();
  const [isOpen, setIsOpen] = useState(false);
  const [query, setQuery] = useState('');
  const inputRef = useRef<HTMLInputElement>(null);

  // Auto-focus the search input every time the submenu opens so keyboard users
  // can start filtering immediately, and reset the query so stale filter state
  // doesn't bleed across opens.
  useEffect(() => {
    if (!isOpen) {
      setQuery('');
      return;
    }
    // `requestAnimationFrame` waits for the popup contents to mount before
    // attempting to focus.
    const id = requestAnimationFrame(() => {
      inputRef.current?.focus();
    });
    return () => cancelAnimationFrame(id);
  }, [isOpen]);

  // Closing the submenu via outside click or Escape only dismisses the
  // submenu itself — the parent "..." menu stays open so the user can pick
  // a different action (rename/delete). `onClose` from the parent is only
  // called when the user actually completes a move/create action.
  const handleClose = useCallback(() => {
    setIsOpen(false);
  }, []);
  const filteredSpaces = useMemo(() => {
    const normalized = query.trim().toLocaleLowerCase();
    if (!normalized) {
      return spaces;
    }
    return spaces.filter(space => space.name.toLocaleLowerCase().includes(normalized));
  }, [spaces, query]);
  const handleQueryChange = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
    setQuery(event.target.value);
  }, []);

  // Fire-and-forget the move action — the same pattern the original inline
  // submenu used. Errors are surfaced by the caller's own toasts / analytics.
  const handleSpaceClick = useCallback((spaceId: string) => {
    setIsOpen(false);
    onClose();
    onConversationMoveToSpace?.(conversation, spaceId);
  }, [conversation, onClose, onConversationMoveToSpace]);
  const handleCreateNewSpace = useCallback(() => {
    setIsOpen(false);
    onClose();
    onConversationMoveToNewSpace?.(conversation);
  }, [conversation, onClose, onConversationMoveToNewSpace]);
  const handleToggleOpen = useCallback(() => setIsOpen(prev => !prev), []);
  if (!onConversationMoveToSpace && !onConversationMoveToNewSpace) {
    return null;
  }
  const hasSpaces = spaces.length > 0;
  const hasMatches = filteredSpaces.length > 0;

  // Centralised renderer for the four mutually-exclusive list states:
  // loading → no-spaces (zero total) → no-matches (filtered to zero) → list.
  const renderListContents = () => {
    if (isLoadingSpaces) {
      return <ButtonItem isDisabled iconBefore={<Spinner size="small" label="" />}>
					{formatMessage(messages.moveToSpaceLoadingLabel)}
				</ButtonItem>;
    }
    if (!hasSpaces) {
      return <ButtonItem isDisabled>{formatMessage(messages.moveToSpaceNoSpacesLabel)}</ButtonItem>;
    }
    if (!hasMatches) {
      return <Box xcss={styles.emptyState} testId={`${TESTID_PREFIX}-move-to-space-no-matches-${testIdDisambiguator}`}>
					<Text color="color.text.subtle" size="small">
						{formatMessage(messages.moveToSpaceNoMatchesLabel, {
            query: query.trim()
          })}
					</Text>
				</Box>;
    }
    return filteredSpaces.map(space => <ButtonItem key={space.id} testId={`${TESTID_PREFIX}-move-to-space-item-${space.id}-${testIdDisambiguator}`} iconBefore={space.emoji ? <ResourcedEmoji emojiId={{
      id: space.emoji,
      shortName: ''
    }} emojiProvider={spaceEmojiProvider} fitToHeight={16} /> : <FolderClosedIcon label="" />} onClick={() => handleSpaceClick(space.id)}>
				{space.name}
			</ButtonItem>);
  };
  return <Popup testId={`${TESTID_PREFIX}-move-to-space-popup-${testIdDisambiguator}`} isOpen={isOpen} onClose={handleClose} zIndex={Z_INDEX_POPUP_COMPONENTS + 1} placement="right-start" content={() => <MenuGroup>
					{/* Search input — pinned at the top. Hidden when the user has no
         spaces yet, since there is nothing to filter and only the
         "Create new space" action is relevant. */}
					{hasSpaces && <Box xcss={styles.searchContainer}>
							<Textfield ref={inputRef} value={query} onChange={handleQueryChange} placeholder={formatMessage(messages.moveToSpaceSearchPlaceholder)} aria-label={formatMessage(messages.moveToSpaceSearchInputLabel)} elemBeforeInput={<Box xcss={styles.searchIconContainer}>
										<SearchIcon label="" color={"var(--ds-icon-subtle, #505258)"} />
									</Box>} testId={`${TESTID_PREFIX}-move-to-space-search-${testIdDisambiguator}`} />
						</Box>}
					{/* Scrollable list of spaces (or the relevant empty/loading state). */}
					<Section>
						<Box xcss={hasSpaces ? styles.scrollableList : undefined}>{renderListContents()}</Box>
					</Section>
					{/* "Create new space" — pinned at the bottom of the submenu, below
         a separator so it stays visually distinct from the list. */}
					{onConversationMoveToNewSpace && <Section hasSeparator>
							<ButtonItem testId={`${TESTID_PREFIX}-move-to-new-space-${testIdDisambiguator}`} iconBefore={<FolderAddIcon label="" />} onClick={handleCreateNewSpace}>
								{formatMessage(messages.moveToSpaceCreateNewLabel)}
							</ButtonItem>
						</Section>}
				</MenuGroup>} trigger={triggerProps => <ButtonItem {...triggerProps} testId={`${TESTID_PREFIX}-history-item-move-to-space-${testIdDisambiguator}`} iconBefore={<FolderClosedIcon label="" />} iconAfter={<ChevronRightIcon label="" />} onClick={handleToggleOpen}>
					{formatMessage(messages.moreMenuMoveToSpaceLabel)}
				</ButtonItem>} />;
};